var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div aria-hidden=\"true\" class=\"coz-notification\"><div class=\"coz-notification-title\"></div><div class=\"coz-notification-message\"></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/views/templates/notification.jade
// module id = 17
// module chunks = 0